import { render, staticRenderFns } from "./payway.vue?vue&type=template&id=1fb14f7a&scoped=true&"
import script from "./payway.vue?vue&type=script&lang=js&"
export * from "./payway.vue?vue&type=script&lang=js&"
import style0 from "./payway.vue?vue&type=style&index=0&id=1fb14f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb14f7a",
  null
  
)

export default component.exports